export function getAuthPageContentPaddingTop({
    isMobile,
    isAuthenticated,
    pathName,
    announcementToolbarHeight,
}) {
    const basePadding = isMobile ? 30 : 18;
    const isAuthPage = pathName === '/login' || pathName === '/signup';
    const measuredBannerHeight = Number(announcementToolbarHeight);
    const bannerOffset = !isAuthenticated && isAuthPage && Number.isFinite(measuredBannerHeight)
        ? Math.max(0, measuredBannerHeight)
        : 0;

    return basePadding + bannerOffset;
}
